import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/hooks/useDebounce';
import CreateModal from '../components/CreateModal';
// import UpdateModal from '../components/UpdateModal';
// import CreatePermissionModal from '../components/CreatePermissionModal';
import RoleManagementContent from './RolesManagementContent';
import * as actions from '../action';
import * as c from '../constant';
import DuplicateModal from '../components/DuplicateModal';

const INIT_FILTER = {
  is_paginated: 1,
  q: '',
  sort_by: 'desc',
  per_page: 10,
};

function RoleManagementContainer({
  match,
  isLoading,
  history,
  getRoleList,
  roleList,
  roleListPager,
  removeRole,
  removePermission,
  getPermissionList,
  createPermission,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getRoleList(debouncedFilter);

    return () => {
      setModal({ isOpen: false });
    };
  }, [JSON.stringify(debouncedFilter)]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Role',
      modalSize: 'modal-md',
    });
  };

  const handleDuplicateModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <DuplicateModal updateList={data.attributes} id={data.id} />,
      title: 'Duplicate Role',
      modalSize: 'modal-md',
    });
  };

  // const handleEdit = (data) => (e) => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: <UpdateModal updateList={data.attributes} id={data.id} />,
  //     title: 'Update Role',
  //     modalSize: 'modal-md',
  //   });
  // };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to remove this role?',
      () => {
        removeRole(data.id, () => {
          getRoleList(INIT_FILTER);
          const id = _.get(roleList, '0.id');
          history.push(`/role-management/${id}`);
          getPermissionList(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  // const handleAddPermissionModal = (id, selectedPermissions) => () => {
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <CreatePermissionModal
  //         id={id}
  //         selectedPermissions={selectedPermissions}
  //       />
  //     ),
  //     title: 'Add Permission',
  //     modalSize: 'modal-md',
  //   });
  // };

  const handleRemovePermission = (roleId, data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to remove this permission?',
      () => {
        removePermission(roleId, data.id, () => {
          getPermissionList(roleId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleAddPermission = (roleId, selectedPermissions) => (e) => {
    e.preventDefault();
    const args = {
      name: selectedPermissions,
    };

    ConfirmAlert(
      'Are you sure you want to add this permission?',
      () => {
        createPermission(roleId, args, () => {
          getPermissionList(roleId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:roleId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Role Management"
            // getData={getRoleList}
            // setParams={formData}
            setKeyword={handleOnChange}
            keyword={filter.q}
            keywordPlaceholder="Search Role..."
            listName="Roles"
            label="Roles List"
            renderItem={(item) => (
              <div className="p-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.name')}
                </div>
              </div>
            )}
            isLoading={isLoading}
            selected={params.roleId}
            data={roleList}
            dataPager={roleListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:roleId?`}
                    render={() => (
                      <RoleManagementContent
                        handleAddModal={handleAddModal}
                        handleDuplicateModal={handleDuplicateModal}
                        // handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        handleAddPermission={handleAddPermission}
                        handleRemovePermission={handleRemovePermission}
                        roleParams={filter}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:roleId?`}
                  render={() =>
                    !params.roleId && roleList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(roleList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        )}
      />
    </div>
  );
}

RoleManagementContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  roleList: PropTypes.instanceOf(Array).isRequired,
  roleListPager: PropTypes.instanceOf(Object).isRequired,
  removeRole: PropTypes.instanceOf(Function).isRequired,
  removePermission: PropTypes.instanceOf(Function).isRequired,
  getPermissionList: PropTypes.instanceOf(Function).isRequired,
  createPermission: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.GET_ROLE) > -1,
  roleList: _.get(api, `${c.GET_ROLE}.list`) || [],
  roleListPager: _.get(api, `${c.GET_ROLE}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(RoleManagementContainer);
